// Central content + media source-of-truth. Add new products/industries/kits here.

export const COMPANY = {
  name: "OneHarvest",
  legal: "OneHarvest LLC",
  tagline: "Best-in-Class Industrial Products & Jobsite Solutions",
  philosophy:
    "We don't sell everything. We focus on providing quality, complimentary products and unmatched service.",
  phone: "(713) 725-7413",
  email: "kyle@oneharvestco.com",
  address: "Houston, TX",
  serviceArea: "Serving operations nationwide.",
  hours: "Mon–Fri 7:00a–6:00p",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_enviro-risk-partner/artifacts/cs4j8upr_oneharvest-logo-2048.webp",
  bonedryLogo: "https://customer-assets-lqy194kg.emergentagent.net/job_enviro-risk-partner/artifacts/64ge1008_msv-bonedry-logo.png",
  bonedryProduct: "/bonedry-barrel-square.jpeg",
  logoWhite: "/oneharvest-white.png",
  logoDark: "/oneharvest-dark.png",
  markWhite: "/oneharvest-mark-white.png",
  markDark: "/oneharvest-mark-dark.png",
  hero: "https://images.pexels.com/photos/24245327/pexels-photo-24245327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  pipeline: "https://images.pexels.com/photos/35602970/pexels-photo-35602970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  excavators: "https://images.unsplash.com/photo-1603814929877-d5d927322656?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bulldozer: "https://images.unsplash.com/photo-1503708928676-1cb796a0891e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  quarry: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  oilRig: "https://images.pexels.com/photos/13129752/pexels-photo-13129752.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pumpjack: "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  offshore: "https://images.pexels.com/photos/11139595/pexels-photo-11139595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  fire: "https://images.pexels.com/photos/20659632/pexels-photo-20659632.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  fireGear: "https://images.pexels.com/photos/19487945/pexels-photo-19487945.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  crew: "https://images.pexels.com/photos/8487341/pexels-photo-8487341.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  aboutHero: "https://images.unsplash.com/photo-1742112125635-6f8201c6ee3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  worker: "https://images.pexels.com/photos/8159/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  fiber: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fireHoses: "https://images.unsplash.com/photo-1700356848746-5f2dd76c237b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  // Products (generated renders)
  bonedry: "https://static.prod-images.emergentagent.com/jobs/c0e747dd-d902-4d85-8b8d-d2a97210c623/images/3b100cc19a24d76c260dff9b16abc7536dfbdb37ae2a98e6621c4a40e6ffaacd.jpeg",
  pinkwater: "https://customer-assets-lqy194kg.emergentagent.net/job_enviro-risk-partner/artifacts/2oo5e89z_IMG_2366.jpeg",
  bigbadmats: "https://customer-assets.emergentagent.com/job_enviro-risk-partner/artifacts/706sve8v_Big%20Bad%20Mat%20Photo.jpg",
  ermkKit: "https://static.prod-images.emergentagent.com/jobs/c0e747dd-d902-4d85-8b8d-d2a97210c623/images/cd3dccf2f3a1a9b1df99dcfe5cd724a2bc91f1eff68dffaf58717310355fbd62.png",
  farmland: "https://images.unsplash.com/photo-1635274142658-9260d3bf88c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pasture: "https://images.unsplash.com/photo-1589674198124-667e1b5b886f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  farmlandWide: "https://images.unsplash.com/photo-1775761053769-a0fa469e0c87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const CATEGORIES = [
  {
    slug: "absorbents",
    name: "Absorbents & Spill Control",
    to: "/absorbents",
    image: "https://images.unsplash.com/photo-1647735282077-c12699af40be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    icon: "Droplets",
    tagline: "High-performance absorbents for oil, fuel, and fluids.",
    desc: "Encapsulate and contain hydrocarbons and industrial fluids fast — on floors, on ground, and on water.",
    faqs: [
      { q: "What types of spills do OneHarvest absorbents handle?", a: "Our absorbents handle oil, diesel, fuel, hydraulic fluid, and a range of industrial liquids — with hydrocarbon-selective options that lock up oil while repelling water, plus formulations for water-based cuttings, caustic, and biofluid cleanup." },
      { q: "Are your absorbents better than clay?", a: "For hydrocarbon spills, yes. Products like BoneDry are up to 5x lighter than clay, use less material, and cut disposal weight — typically lowering cost per incident by roughly half." },
      { q: "Do you supply spill kits and containment products?", a: "Yes — alongside loose absorbent we supply pads, socks, booms, portable and full-size spill kits, and readiness kits that can be standardized across your fleet." },
      { q: "Can you help us choose the right absorbent?", a: "Absolutely. We qualify the liquid, surface, and disposal path before recommending a product, so you buy exactly what fits your operation." },
    ],
  },
  {
    slug: "water-treatment",
    name: "Water Treatment & Management",
    to: "/water-treatment",
    image: "https://images.unsplash.com/photo-1693907986952-3cd372e4c9d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    icon: "Waves",
    tagline: "Turn problem water into compliant water.",
    desc: "Clarify, condition, and manage jobsite water to support discharge compliance and cut disposal costs.",
    faqs: [
      { q: "What does PinkWater treatment do?", a: "Our water treatment solutions clarify and condition contaminated jobsite water — supporting discharge compliance and reducing the volume you have to haul and dispose of." },
      { q: "Where is jobsite water treatment used?", a: "Common applications include construction dewatering, hydrostatic testing, wash-water treatment, and sediment control." },
      { q: "How much can on-site treatment save?", a: "Treating water on site instead of hauling it off can lower total water-management cost by up to roughly 60%, while shortening project delays." },
      { q: "How do you determine the right dosing?", a: "We confirm your water volume, contaminant type, discharge requirements, and treatment frequency before quoting, so you get the right configuration and dose — not the biggest one." },
    ],
  },
  {
    slug: "ground-protection",
    name: "Ground Protection & Site Access",
    to: "/ground-protection",
    image: IMAGES.bigbadmats,
    icon: "LayoutGrid",
    tagline: "Your single source for any site-access mat.",
    desc: "We source and supply any ground protection or site-access matting that fits your project — flagship Big Bad Mats when durability matters most.",
    faqs: [
      { q: "Can I rent or buy ground protection mats?", a: "Both. Buy the product outright, or opt for a full turnkey service where we deliver, install, maintain, and remove the matting (rental included) — for your project or the client you serve." },
      { q: "What types of mats do you supply?", a: "We're a single source for composite mats, heavy-duty crane and rig pads, access-road and specialty matting, and connectors, ramps, and accessories — including flagship Big Bad Mats." },
      { q: "How do you choose the right mat?", a: "We match the mat to your equipment loads, ground conditions, and access distance — so you deploy the right mat, not just more mats." },
      { q: "Do mats reduce project cost?", a: "Reusable composite matting delivers far lower cost per use and near-zero site restoration versus gravel, timber, or plywood — up to roughly 55% lower total access cost over a project." },
    ],
  },
];

export const PRODUCTS = [
  {
    slug: "bonedry",
    name: "BoneDry",
    faqs: [
      { q: "What types of spills do BoneDry absorbents handle?", a: "BoneDry is a high-performance granular absorbent engineered to encapsulate hydrocarbons — oil, diesel, and fuel — on contact. It's ideal for fleet maintenance yards, fueling operations, readiness kits, and shop floors." },
      { q: "Does BoneDry absorb water?", a: "No — BoneDry absorbs oil and fuel while repelling water, and it floats on water for rapid surface recovery of hydrocarbon spills." },
      { q: "How is BoneDry different from clay absorbents?", a: "BoneDry is up to 5x lighter than clay, so crews use less material, spend less time on cleanup, and haul away far less disposal weight — up to roughly 50% lower cost per incident." },
      { q: "What packaging is BoneDry available in?", a: "BoneDry is available in 3 lb resealable bags, 2-cubic-foot bags, super sacks, drums, portable spill kits, socks, and booms. Availability is confirmed before quoting." },
    ],
    category: "Hydrocarbon Absorbent",
    categorySlug: "absorbents",
    image: IMAGES.bonedryProduct,
    packaging: [
      {
        name: "2 Cubic Foot Bag",
        tagline: "Best for high-volume applications",
        image: "https://static.prod-images.emergentagent.com/jobs/c0e747dd-d902-4d85-8b8d-d2a97210c623/images/3b100cc19a24d76c260dff9b16abc7536dfbdb37ae2a98e6621c4a40e6ffaacd.jpeg",
        points: [
          "Maximum value — a little goes a long way",
          "Covers large areas quickly",
          "Ideal for maintenance departments & fleet yards",
          "Industrial plants & large spill response",
        ],
      },
      {
        name: "3 LB Resealable Bag",
        tagline: "Spill-response ready",
        image: "https://static.prod-images.emergentagent.com/jobs/c0e747dd-d902-4d85-8b8d-d2a97210c623/images/58783cc990782c11317fab8ad818f78e580225e7deb1fc34a708f3308c29e0e5.jpeg",
        points: [
          "Resealable, lightweight & easy to carry",
          "Convenient storage anywhere",
          "Perfect for vehicles, tool boxes & emergency kits",
          "Ready whenever you need it",
        ],
      },
      {
        name: "Super Sacks",
        tagline: "Bulk industrial supply",
        image: "https://static.prod-images.emergentagent.com/jobs/c0e747dd-d902-4d85-8b8d-d2a97210c623/images/177c631c0a38eceb250d533d0c412b078b528d7024319302ca8ae7c01e0b53aa.jpeg",
        points: [
          "Reduced packaging waste & lower cost per pound",
          "Efficient bulk storage",
          "Works with bulk material-handling equipment",
          "Refineries, ports, chemical & large manufacturing plants",
        ],
      },
    ],
    tagline: "Best-in-class hydrocarbon absorbent that locks up oil and fuel on contact.",
    summary:
      "A high-performance granular absorbent engineered to encapsulate hydrocarbons — oil, diesel, and fuel — fast. Non-leaching, lightweight, and floats on water for rapid surface recovery.",
    highlights: [
      "Absorbs oil & fuel, repels water",
      "Encapsulates hydrocarbons to reduce leaching",
      "Lightweight — up to 5x lighter than clay",
      "Ideal for maintenance & rapid response",
    ],
    applications: ["Fleet maintenance yards", "Fueling operations", "Readiness kits", "Shop & equipment floors"],
    useCases: ["Routine equipment maintenance", "Fuel & fluid containment", "Rapid spill response"],
    sectors: ["oil-gas", "pipeline-construction", "heavy-construction", "civil-construction", "utility-contractors", "directional-drilling", "hazmat-response", "fire-departments", "industrial-facilities", "municipal-public-works"],
    costBenefit: {
      intro: "Because BoneDry is lightweight and encapsulates hydrocarbons, crews use less material, spend less time on cleanup, and haul away far less disposal weight than with conventional clay absorbents.",
      conventionalLabel: "Conventional clay absorbent",
      productLabel: "BoneDry",
      savingsHeadline: "Up to ~50% lower cost per incident",
      metrics: [
        { label: "Absorbent volume used", conventional: 100, oneharvest: 38 },
        { label: "Cleanup labor time", conventional: 100, oneharvest: 55 },
        { label: "Disposal weight & hauling", conventional: 100, oneharvest: 40 },
        { label: "Slip / rework risk", conventional: 100, oneharvest: 45 },
        { label: "Total cost per incident", conventional: 100, oneharvest: 50 },
      ],
      disclaimer: "Illustrative; actual results vary by spill type, surface, and disposal path.",
    },
    premierLine: {
      kicker: "Premier Product Line",
      forSaleLabel: "Entire BoneDry Premier Product Line — For Sale",
      title: "The BoneDry Premier Product Line",
      intro:
        "BoneDry is a full spill cleanup and containment line. We qualify your liquid type, surface, disposal path, and current cleanup cost before recommending a specific product — so you buy exactly what fits your operation.",
      products: [
        {
          name: "BoneDry All",
          bestFit:
            "General oil- or water-based spills on hard surfaces across industrial, municipal, utility, retail, and commercial sites.",
          react:
            "For mixed spill types when you want one reliable absorbent. Positioned for oil or water-based liquids on hard surfaces — non-toxic, non-abrasive, and non-leaching.",
        },
        {
          name: "BoneDry HC",
          bestFit:
            "Hydrocarbons: diesel, lubricants, hydraulic fluid, brake fluid, transmission fluid, petroleum residue, oil-based mud cuttings, and oil spills in wet environments.",
          react:
            "\u201cAbsorbs oil, not water.\u201d Ideal for wet environments where leaving the water behind matters. HC absorbs hydrocarbons and will not absorb water.",
        },
        {
          name: "BoneDry H2O",
          bestFit:
            "Water-based mud cuttings and solidification where dry loads, hauling, landfill acceptance, or rejected-load risk matter.",
          react:
            "Best fit for drilling, HDD, and cuttings cleanup. Focus on dry loads, less tonnage, and fewer disposal headaches — validate the customer\u2019s landfill/internal requirements.",
        },
        {
          name: "BoneDry SC",
          bestFit:
            "Spent caustic drips/spills, sulfide or mercaptan odor contexts, pump areas, loading/unloading, tank bottoms, fittings, and sample collection.",
          react:
            "Use where hazardous cleanup, odor, corrosive surfaces, or caustic exposure are the pain. SC minimizes/removes odors from sulfides, mercaptans, volatiles, and semi-volatiles.",
        },
        {
          name: "BoneDry Crime",
          bestFit: "Biofluid cleanup: vomit, blood, urine, feces.",
          react:
            "Fit for crime scene, hospitality, schools, retail, transit, healthcare-adjacent, custodial, and public-facing facilities. Captures biofluids, reduces smell, and leaves a non-slip, residue-free surface.",
        },
        {
          name: "Containment Products",
          bestFit:
            "Oil spill containment, readiness, drains, warehouses, factories, boats, vehicles, and water-adjacent operations.",
          react:
            "Includes booms, socks, bilge mini-booms, portable spill kits, and full-size universal spill kits. Oil-only booms and socks absorb oils, fuels, lubricants, and hydrocarbons — not water.",
        },
      ],
      packaging:
        "BoneDry products are available in travel jugs, 3 lb resealable bags, 2-cubic-foot bags, drums, super sacks, portable spill kits, full-size spill kits, socks, booms, and bilge mini-booms. Availability is confirmed before quoting.",
      closing:
        "The BoneDry Premier cleanup line covers general absorbent, hydrocarbon-only, water-based cuttings solidifier, spent caustic cleanup, biofluid cleanup, and containment products. Before we recommend a bag or kit, we\u2019ll want to know what you\u2019re cleaning up, where it happens, how often it happens, and what the used material costs you in labor, hauling, and disposal.",
      disposal:
        "BoneDry is used to pick up hazardous or toxic materials; it is the user\u2019s responsibility to safely dispose of these materials in accordance with federal, state, and local regulations.",
    },
  },
  {
    slug: "pinkwater",
    name: "Pinkwater",
    faqs: [
      { q: "What is Pinkwater used for?", a: "Pinkwater is an industrial water-treatment solution that clarifies and conditions contaminated jobsite water — supporting discharge compliance and reducing costly hauling and disposal." },
      { q: "Where is Pinkwater typically used?", a: "Common applications include construction dewatering, hydrostatic testing, wash-water treatment, and sediment control." },
      { q: "How does Pinkwater lower water-management costs?", a: "Treating water on site reduces the volume you haul and dispose of, shortens project delays, and can lower total water-management cost by up to roughly 60%." },
      { q: "What sizes does Pinkwater come in?", a: "Pinkwater is available in 1-gallon jugs, 5-gallon pails, 55-gallon drums, and 275-gallon IBC totes. Availability and dosing rates are confirmed before quoting." },
    ],
    category: "Spill Remediation Solution",
    categorySlug: "water-treatment",
    image: IMAGES.pinkwater,
    fit: "contain",
    tagline: "Industrial water treatment that turns problem water into compliant water.",
    summary:
      "A treatment solution that clarifies and conditions contaminated jobsite water, supporting discharge compliance and reducing costly hauling and disposal.",
    highlights: [
      "Rapid clarification of turbid water",
      "Supports discharge compliance",
      "Reduces hauling & disposal costs",
      "Scalable for jobsite dewatering",
    ],
    applications: ["Construction dewatering", "Hydrostatic testing", "Wash-water treatment", "Sediment control"],
    useCases: ["Construction dewatering", "Discharge compliance", "Wash-water & sediment management"],
    sectors: ["pipeline-construction", "heavy-construction", "civil-construction", "directional-drilling", "utility-contractors", "underground-fiber", "industrial-facilities", "municipal-public-works"],
    costBenefit: {
      intro: "Treating water on site with Pinkwater reduces the volume you haul and dispose of, shortens project delays, and lowers the total cost of managing contaminated jobsite water.",
      conventionalLabel: "Haul-off & disposal",
      productLabel: "Pinkwater",
      savingsHeadline: "Up to ~60% lower water management cost",
      metrics: [
        { label: "Water hauling & disposal", conventional: 100, oneharvest: 30 },
        { label: "Treatment labor", conventional: 100, oneharvest: 60 },
        { label: "Project downtime / delays", conventional: 100, oneharvest: 45 },
        { label: "Compliance / rework risk", conventional: 100, oneharvest: 40 },
        { label: "Total water management cost", conventional: 100, oneharvest: 40 },
      ],
      disclaimer: "Illustrative; actual results vary by water volume, contaminants, and discharge requirements.",
    },
    premierLine: {
      kicker: "Product Line & Configurations",
      forSaleLabel: "Pinkwater Configurations — For Sale",
      title: "The Pinkwater Line, Sized to Your Project",
      intro:
        "BioSolve Pinkwater is available in multiple configurations so you can match volume to your dewatering, testing, and wash-water needs. We help you right-size the container and dosing before quoting.",
      products: [
        {
          name: "Pinkwater — 1 Gallon Jug",
          bestFit: "Spot treatment, small wash-water tasks, and on-site trials.",
          react: "A low-commitment entry point for evaluating performance on your water before scaling up.",
        },
        {
          name: "Pinkwater — 5 Gallon Pail",
          bestFit: "Recurring small-to-mid volume dewatering and wash-water treatment.",
          react: "Fits crews that treat water regularly but don\u2019t need bulk storage on site.",
        },
        {
          name: "Pinkwater — 55 Gallon Drum",
          bestFit: "Sustained treatment on active jobsites and ongoing programs.",
          react: "Best for continuous dewatering programs and pipeline work.",
        },
        {
          name: "Pinkwater — 275 Gallon Tote (IBC)",
          bestFit: "High-volume, continuous treatment and bulk dosing.",
          react: "For large dewatering or hydrostatic testing programs where downtime and re-ordering matter.",
        },
      ],
      packaging:
        "Pinkwater is available in 1-gallon jugs, 5-gallon pails, 55-gallon drums, and 275-gallon IBC totes. Availability and dosing rates are confirmed before quoting.",
      closing:
        "Before we recommend a container size and dosing rate, we\u2019ll want to know your water volume, contaminant type, discharge requirements, and how often you treat \u2014 so you buy the right configuration, not the biggest one.",
    },
  },
  {
    slug: "big-bad-mats",
    name: "Big Bad Mats",
    faqs: [
      { q: "What are Big Bad Mats used for?", a: "Big Bad Mats and our ground-protection matting create temporary access roads, crane and rig pads, and work platforms that support heavy equipment while protecting turf, soil, and sensitive ground." },
      { q: "Can I rent mats or do I have to buy them?", a: "Both. You can buy the product outright, or opt for a full turnkey service where we deliver, install, maintain, and remove the matting (rental included) for your project or the client you serve." },
      { q: "What types of mats can OneHarvest source?", a: "We're a single source for composite mats, heavy-duty crane and rig pads, access-road and specialty matting, and connectors, ramps, and accessories — sourced to your loads and ground conditions." },
      { q: "How do Big Bad Mats reduce cost?", a: "Reusable composite matting delivers far lower cost per use and near-zero site restoration versus gravel, timber, or plywood — up to roughly 55% lower total access cost over a project." },
    ],
    cardTitle: "Any Mat You Need",
    category: "Ground Protection Systems",
    categorySlug: "ground-protection",
    image: IMAGES.bigbadmats,
    tagline: "Your single source for ground protection & site access — flagship Big Bad Mats.",
    summary:
      "We're your single source for all ground protection and site-access matting. We source whatever mat makes the most sense for your project — composite, timber, crane pads, and more, with the flagship Big Bad Mats when durability and reuse matter most. Then get it the way that works for you: buy the product from us, or have us provide a full turnkey service.",
    highlights: [
      "Any mat that makes the most sense for your project — one source",
      "Flagship Big Bad Mats for maximum durability & reuse",
      "Buy the product, or opt for a full turnkey service",
      "Supports heavy equipment loads; protects sensitive ground",
    ],
    applications: ["Access roads", "Crane & rig pads", "Utility right-of-way", "Temporary access"],
    useCases: ["Temporary access roads", "Equipment & crane work platforms", "Turf & soil protection"],
    sectors: ["oil-gas", "pipeline-construction", "heavy-construction", "civil-construction", "utility-contractors", "directional-drilling", "telecommunications", "underground-fiber", "municipal-public-works"],
    costBenefit: {
      intro: "Reusable composite matting costs more up front than gravel, plywood, or timber, but delivers far lower cost per use and near-zero site restoration — driving down total ground-protection cost over a project.",
      conventionalLabel: "Gravel / timber / plywood",
      productLabel: "Big Bad Mats",
      savingsHeadline: "Up to ~55% lower total access cost",
      metrics: [
        { label: "Material & installation", conventional: 100, oneharvest: 65 },
        { label: "Cost per use (reusability)", conventional: 100, oneharvest: 30 },
        { label: "Site restoration / cleanup", conventional: 100, oneharvest: 25 },
        { label: "Equipment downtime", conventional: 100, oneharvest: 50 },
        { label: "Total ground-protection cost", conventional: 100, oneharvest: 45 },
      ],
      disclaimer: "Illustrative; actual results vary by ground conditions, loads, and project duration.",
    },
    premierLine: {
      kicker: "Single-Source Matting",
      forSaleLabel: "Ground Protection & Site Access — Buy or Rent",
      title: "One Source for Every Mat. Flagship Big Bad Mats.",
      intro:
        "We supply whatever ground-protection or site-access mat makes the most sense for your project — sourced to your equipment loads, ground conditions, and access needs. Big Bad Mats is the flagship system for maximum durability and reuse, and we'll source composite, timber, crane pads, or specialty matting wherever it fits better. However you want it, we make it simple: buy the product from us, or let us handle everything with a full turnkey service.",
      products: [
        {
          name: "Big Bad Mats (Flagship)",
          bestFit: "The workhorse for most jobsite access and work platforms on turf, soil, and sensitive ground.",
          react: "The flagship composite mat — recommended when durability, reuse, and lowest cost-per-use matter most.",
        },
        {
          name: "Heavy-Duty Crane & Rig Pads",
          bestFit: "Outrigger pads and platforms under cranes, rigs, and concentrated point loads.",
          react: "Sourced where load ratings and stability under heavy equipment are the priority.",
        },
        {
          name: "Access Road & Specialty Matting",
          bestFit: "Temporary haul roads and right-of-way access across long, soft, or wet stretches.",
          react: "We source composite, timber, or specialty matting to fit pipeline ROW, utility, and remote-access projects.",
        },
        {
          name: "Connectors, Ramps & Accessories",
          bestFit: "Securing mat systems, transitions, and edge ramps for equipment.",
          react: "Round out any deployment for safe transitions and a stable, connected surface.",
        },
      ],
      packaging:
        "Buy the product outright, or opt for a full turnkey service where we deliver, install, maintain, and remove the matting (rental included) — for your project or the client you serve. We source any mat that fits the job; mats ship with connection hardware and optional ramps. Sizes, load ratings, and availability are confirmed before quoting.",
      closing:
        "Before we recommend a mat type and quantity, we\u2019ll want to know your equipment weights, ground conditions, access distance, and project duration \u2014 so you deploy the right mat, not just more mats.",
    },
  },
];

export const KITS = [
  { slug: "lite", name: "ERMK Lite", for: "Single trucks & light crews", desc: "Essential spill readiness for a single vehicle or small crew — compact, cab-ready, and always within reach." },
  { slug: "pro", name: "ERMK Pro", for: "Field crews & service teams", desc: "Expanded absorbents, PPE, and response tools for active field crews handling routine fuels and fluids." },
  { slug: "fleet", name: "ERMK Fleet", for: "Multi-vehicle operations", desc: "Standardized readiness across an entire fleet with inventory tracking and automatic replenishment." },
  { slug: "pipeline", name: "ERMK Pipeline", for: "Pipeline construction & integrity", desc: "Configured for right-of-way work, hydrostatic testing, and large-volume hydrocarbon exposure." },
  { slug: "fire", name: "ERMK Fire", for: "Fire departments & first responders", desc: "Rapid-deploy response for departments managing vehicle accidents, fuel spills, and hazmat calls." },
  { slug: "industrial", name: "ERMK Industrial", for: "Plants & fixed facilities", desc: "Facility-scale spill preparedness with SPCC-aligned contents and station-based deployment." },
];

export const ERMK_CONTENTS = [
  "BoneDry Hydrocarbon Absorbent",
  "Pinkwater Water Treatment",
  "Spill Socks & Booms",
  "Absorbent Pads",
  "Personal Protective Equipment (PPE)",
  "Disposal Bags",
  "Quick Reference Spill Response Guide",
  "Truck Inspection Checklist",
  "Inventory Checklist",
  "Emergency Contact Information",
  "QR Codes — training & product documentation",
];

export const INDUSTRIES = [
  { slug: "oil-gas", name: "Oil & Gas", image: IMAGES.pumpjack, blurb: "Upstream, midstream, and field operations that demand reliable industrial products and dependable supply.", useCases: ["Site access & matting", "Fluid & fuel management", "Maintenance readiness"] },
  { slug: "pipeline-construction", name: "Pipeline Construction", image: IMAGES.pipeline, blurb: "Right-of-way work and integrity projects supported by matting, water management, and absorbents.", useCases: ["ROW ground protection", "Hydrostatic test water", "Fluid containment"] },
  { slug: "heavy-construction", name: "Heavy Construction", image: IMAGES.excavators, blurb: "Earthwork and site development where equipment access, water, and fluids all need managing.", useCases: ["Access roads & pads", "Dewatering", "Equipment maintenance"] },
  { slug: "civil-construction", name: "Civil Construction", image: IMAGES.bulldozer, blurb: "Roads, bridges, and infrastructure projects under strict environmental and compliance oversight.", useCases: ["Sediment & water control", "Ground protection", "Fluid management"] },
  { slug: "utility-contractors", name: "Utility Contractors", image: IMAGES.quarry, blurb: "Underground and overhead utility work across dispersed, mobile jobsites.", useCases: ["Temporary access", "Dewatering", "Maintenance supplies"] },
  { slug: "directional-drilling", name: "Directional Drilling", image: IMAGES.excavators, blurb: "HDD operations managing drilling fluids, returns, and site access.", useCases: ["Drilling fluid management", "Bore pit matting", "Water treatment"] },
  { slug: "telecommunications", name: "Telecommunications", image: IMAGES.fiber, blurb: "Network build-outs and tower work across sensitive and public terrain.", useCases: ["Ground protection", "Site access", "Crew supplies"] },
  { slug: "underground-fiber", name: "Underground Fiber", image: IMAGES.fiber, blurb: "Trenching and boring crews needing ground protection and water management.", useCases: ["Access matting", "Dewatering", "Fluid handling"] },
  { slug: "hazmat-response", name: "Hazmat Response", image: IMAGES.fire, blurb: "Teams that must be equipped and compliant before the call comes in.", useCases: ["Absorbents & containment", "Readiness kits", "Rapid resupply"] },
  { slug: "fire-departments", name: "Fire Departments", image: IMAGES.fireGear, blurb: "First responders managing vehicle accidents, fuel incidents, and hazmat calls.", useCases: ["Absorbents", "Response kits", "PPE & supplies"] },
  { slug: "industrial-facilities", name: "Industrial Facilities", image: IMAGES.offshore, blurb: "Plants and fixed sites with continuous operations and compliance obligations.", useCases: ["Facility absorbents", "Water treatment", "Managed inventory"] },
  { slug: "municipal-public-works", name: "Municipal Public Works", image: IMAGES.worker, blurb: "Public agencies protecting waterways, roads, and community infrastructure.", useCases: ["Water & sediment control", "Ground protection", "Maintenance supplies"] },
];

export const SERVICES = [
  { name: "Dedicated Account Management", desc: "A single point of contact who knows your operation, your fleet, and your risks." },
  { name: "Environmental Readiness Assessments", desc: "On-site evaluation of your spill preparedness and compliance posture." },
  { name: "Fleet Risk Reviews", desc: "Vehicle-by-vehicle review to standardize readiness across your fleet." },
  { name: "Inventory Management", desc: "We track what you have, what you've used, and what you need next." },
  { name: "Annual Kit Inspections", desc: "Scheduled inspections keep every ERMK compliant and mission-ready." },
  { name: "Automatic Replenishment", desc: "Consumables restocked before you run short — never scrambling mid-project." },
  { name: "Emergency Delivery", desc: "Rapid delivery of critical supplies when a project can't wait." },
  { name: "Environmental Consulting", desc: "Guidance on spill planning, compliance, and best practices." },
  { name: "Training", desc: "Crew training on spill response, product use, and documentation." },
  { name: "Product Demonstrations", desc: "Hands-on demos so your team trusts the gear before they need it." },
  { name: "Vendor Coordination", desc: "We coordinate manufacturers and logistics so you don't have to." },
  { name: "Spill Preparedness Planning", desc: "Custom response plans mapped to your sites and risks." },
];

export const DIFFERENCE = [
  "Dedicated Account Management",
  "Customized Recommendations",
  "Fleet Assessments",
  "Jobsite Evaluations",
  "Product Training",
  "Inventory Planning",
  "Annual Reviews",
  "Rapid Response",
  "Emergency Support",
  "Technical Expertise",
  "Long-Term Partnership",
];

export const RESOURCES = [
  { title: "Spill Response Quick Guide", type: "Guide", desc: "Step-by-step field reference for the first five minutes of a spill.", file: "spill-response-quick-guide.pdf" },
  { title: "Truck Inspection Checklist", type: "Checklist", desc: "Standardized inspection to keep every vehicle spill-ready.", file: "truck-inspection-checklist.pdf" },
  { title: "ERMK Inventory Checklist", type: "Checklist", desc: "Track kit contents and know exactly when to replenish.", file: "ermk-inventory-checklist.pdf" },
  { title: "Environmental Best Practices", type: "Guide", desc: "Practical guidance for reducing environmental risk on the jobsite.", file: "environmental-best-practices.pdf" },
  { title: "BoneDry Product Data Sheet", type: "Data Sheet", desc: "Technical specifications and application guidance for BoneDry.", file: "bonedry-data-sheet.pdf" },
  { title: "Pinkwater Product Data Sheet", type: "Data Sheet", desc: "Treatment specifications and compliance information.", file: "pinkwater-data-sheet.pdf" },
  { title: "Ground Protection Safety Guide", type: "Safety Guide", desc: "Safe deployment and load guidance for Big Bad Mats.", file: "big-bad-mats-safety-brief.pdf" },
  { title: "Spill Response Training Series", type: "Training Video", desc: "On-demand video training for crews and new hires.", file: "spill-response-training-series.pdf" },
  { title: "Manufacturer Literature Library", type: "Literature", desc: "Brochures and cut sheets from the manufacturers we represent.", file: "manufacturer-literature-library.pdf" },
  { title: "Resource Preservation Flyer", type: "Flyer", desc: "How BoneDry, Pinkwater & Big Bad Mats protect the land as a long-cycle asset.", file: "resource-preservation-flyer.pdf" },
];

export const MANUFACTURERS = [
  { name: "BoneDry", focus: "Hydrocarbon Absorbents" },
  { name: "Pinkwater", focus: "Water Treatment" },
  { name: "Big Bad Mats", focus: "Ground Protection Systems" },
];

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "Products",
    to: "/solutions",
    children: [
      { label: "Absorbents & Spill Control", to: "/absorbents" },
      { label: "Water Treatment & Management", to: "/water-treatment" },
      { label: "Ground Protection", to: "/ground-protection" },
      { label: "Premium Mats", to: "/premium-mats" },
    ],
  },
  { label: "Sectors", to: "/industries" },
  { label: "Stewardship", to: "/land-stewardship" },
  { label: "Resources", to: "/resources" },
  { label: "Blog", to: "/blog" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];
